import React, { Component } from 'react';

import Header from '../components/partials/header.component';
import Sidebar from '../components/partials/sidebar.component';
import { Link } from 'react-router-dom';
import Loader from '../components/Loader';
import Paginate from '../components/Pagination';
import NewsService from '../services/news.service';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import EachNews from './eachnews';
import pageHeader from '../cssmodules/pageheader.module.scss';
export default class DeletedNews extends Component {
  constructor(props) {
    super(props);

    this.handlePagination = this.handlePagination.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.restoreNews = this.restoreNews.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.state = {
      news: [],
      loading: true,
      errmessage: '',
      successmessage: '',
      pagination: '',
      page: 1,
      showModal: false,
      newsToRestore: '',
      createLoading: false,
    };
  }

  async componentDidMount() {
    let allNews = await NewsService.getDeleted();

    this.setState({
      news: allNews.data,
      pagination: allNews.meta,

      loading: false,
    });
  }

  async handlePagination(page) {
    this.setState({
      loading: true,
    });

    let allNews = await NewsService.getDeleted({
      page,
    });

    this.setState({
      news: allNews.data,
      pagination: allNews.meta,

      loading: false,
    });
  }

  changeStatus(e) {
    if (e.target.value === 'active') {
      this.props.history.push('/news');
    }
  }

  fadeOut() {
    setTimeout(
      function () {
        this.setState({ successmessage: '' });
      }.bind(this),
      4000,
    );
  }

  toggleModal(id, title) {
    this.setState({
      showModal: !this.state.showModal,
      newsToRestore: {
        id,
        title,
      },
      errmessage: '',
      successmessage: '',
    });
  }

  restoreNews() {
    this.setState({
      createLoading: true,
    });

    NewsService.restoreNews(this.state.newsToRestore.id).then(
      (response) => {
        let news = [...this.state.news];
        let newsFiltered = news.filter(
          (news) => news._id !== this.state.newsToRestore.id,
        );
        this.setState({
          successmessage: `News "${this.state.newsToRestore.title}" restored successfully`,
          createLoading: false,
          news: newsFiltered,
          showModal: !this.state.showModal,
        });

        if (this.state.news.length === 0) {
          this.handlePagination(
            this.state.pagination.currentPage === 1
              ? 1
              : this.state.pagination.currentPage - 1,
          );
        }

        this.fadeOut();
      },
      (error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.data) ||
          error.message ||
          error.toString();

        this.setState({
          createLoading: false,
          errmessage: resMessage,
        });
      },
    );
  }

  render() {
    const { news, loading } = this.state;

    return (
      <div>
        <Header history={this.props.history} />
        <div className="container-fluid">
          <div className="row">
            <Sidebar history={this.props.history} />

            <main
              role="main"
              className="col-md-9 ml-sm-auto col-lg-10 pt-3 px-4"
            >
              <div className={pageHeader.colHeader}>
                <h1 className={pageHeader.leftSide}>Deleted News</h1>
                <div className={pageHeader.rightSide}>
                  <select
                    name="status"
                    className="form-control status"
                    onChange={this.changeStatus}
                    value="deleted"
                  >
                    <option value="active">Active</option>
                    <option value="deleted">Deleted</option>
                  </select>
                </div>
              </div>

              {loading && (
                <div className="row">
                  <Loader />
                </div>
              )}

              {this.state.successmessage && (
                <div className="form-group">
                  <div className="alert alert-success" role="alert">
                    {this.state.successmessage}
                  </div>
                </div>
              )}

              <div className="row">
                <div className="col-md-12">
                  {news.map((news, index) => (
                    <EachNews
                      key={news._id}
                      _id={news._id}
                      title={news.title}
                      description={news.description}
                      createdAt={news.createdAt}
                      isEven={index % 2 === 0}
                      restoreBtnStatus={true}
                      toggleModal={(_id, title) => this.toggleModal(_id, title)}
                    />
                  ))}
                </div>
              </div>
              {news.length > 0 && (
                <div className="pagination-section">
                  <Paginate
                    pages={this.state.pagination.pages}
                    currentPage={this.state.pagination.currentPage}
                    handlePagination={this.handlePagination}
                  />
                </div>
              )}

              <Modal
                isOpen={this.state.showModal}
                toggle={this.toggleModal}
                className="modal"
              >
                <ModalHeader>Restore News</ModalHeader>

                <ModalBody>
                  <div class="text-center">
                    {' '}
                    Are you sure to restore the news "
                    {this.state.newsToRestore.title}"
                  </div>
                  {this.state.errmessage && (
                    <div className="form-group">
                      <div
                        className="alert alert-danger error-flash-message"
                        role="alert"
                      >
                        {this.state.errmessage}
                      </div>
                    </div>
                  )}
                  {this.state.successmessage && (
                    <div className="form-group">
                      <div className="alert alert-success" role="alert">
                        {this.state.successmessage}
                      </div>
                    </div>
                  )}
                </ModalBody>
                <ModalFooter>
                  <div className="form-group">
                    <Button
                      color="primary"
                      disabled={this.state.createLoading}
                      onClick={this.restoreNews}
                    >
                      <i className="fa fa-check" aria-hidden="true"></i>Ok
                      {this.state.createLoading && (
                        <span className="spinner-border spinner-border-sm"></span>
                      )}
                    </Button>
                    <Button color="secondary" onClick={this.toggleModal}>
                      <i class="fa fa-close" aria-hidden="true"></i>Cancel
                    </Button>
                  </div>
                </ModalFooter>
              </Modal>
            </main>
          </div>
        </div>
      </div>
    );
  }
}
